import * as React from 'react';
import { View } from 'react-native';
import Fonts from '../constants/Fonts';
import { Text } from 'native-base';
import { formatTweetDate, formatTweetTime, formatTweetText } from '../utils/TweetUtils';
import { ScreenStyles } from '../styles/AppStyles';

type LiveFeedState = {
    isLoading: boolean,
    liveTweets: Array<any>,
    liveLimit: number,
    liveSkip: number,
}

class LiveFeed extends React.Component<{}, LiveFeedState> {

    constructor(props: any) {
        super(props)
        this.state = {
            isLoading: true,
            liveTweets: [],
            liveLimit: 1,
            liveSkip: 0,
        }
    }

    async componentDidMount() {
        await this.getLiveTweets();
        const intervalId = setInterval(() => {
            this.getLiveTweets();
        }, 8000)
        return () => clearInterval(intervalId);
    }

    async getLiveTweets() {
        this.setState({ isLoading: true })
        await fetch(`https://tweets.data-well.workers.dev/tweets-next?limit=1&skip=0`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
            .then((data: any) => {
                if (!this.state.liveTweets || this.state.liveTweets.length === 0) {
                    this.setState({ liveTweets: data })
                    this.setState({ isLoading: false })
                }
                try {
                    this.addToLiveList(data);
                } catch (error) {
                    throw error;
                }

            })
    }

    private addToLiveList(data: any) {
        const lastId = this.state.liveTweets[0] && this.state.liveTweets[0].id && this.state.liveTweets[0].id;
        if (this.state.liveTweets.length >= 1 && lastId !== undefined) {
            if (lastId !== data[data.length - 1].id) {
                this.setState((state) => ({
                    liveTweets: [...data, ...state.liveTweets]
                }));
                this.setState({ isLoading: false });
            }
        }
    }

    render() {
        const { liveTweets } = this.state;
        return (
            <>
                {liveTweets && liveTweets.map(
                    (tweet: any, i: number) => {
                        let background = {};
                        let backgroundHr = {borderColor: '#DDDDDD', borderBottomWidth: 1};
                        let fontColor = {}
                        if (i === 0) {
                            fontColor = {color:'white', fontWeight: 'bold'}
                            background = { backgroundColor: '#130202' }
                            backgroundHr = { borderColor: '#ED203D', borderBottomWidth: 2 }
                        }

                        return (
                            <View key={i} style={[background,ScreenStyles.containerCard, backgroundHr]} data-date={formatTweetDate(tweet.createdAt)}>
                                <Text style={[{ textAlign: 'right' }, Fonts.label, fontColor]}>{formatTweetTime(tweet.createdAt)}</Text>
                                <Text key={`${i}p`} style={[{ textAlign: 'left', padding: 16,  }, Fonts.p, fontColor]}>{
                                    tweet.extended_tweet
                                        ? formatTweetText(tweet.extended_tweet.full_text)
                                        : formatTweetText(tweet.text)
                                }</Text>
                            </View>
                        )
                    })
                }
            </>
        );
    }
}


export default LiveFeed;